import styled, { CSSObject } from '@emotion/styled'
import ContentLoader from 'react-content-loader'
import { StoreContainer } from '../Landing/Stores/Store'
import { useMediaQueries } from 'shop/hooks'
import { StyledHTMLElement } from 'shop/theme/types'

export const ProductImageLoader = () => (
  <ContentLoader>
    <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
  </ContentLoader>
)

export const CategoryLoader = ({ ...props }) => (
  <ContentLoader width={140} height={1} {...props}>
    <rect x='62' y='0' rx='0' ry='0' width='8' height={4} />
    <rect x='72' y='0' rx='0' ry='0' width='8' height={4} />
  </ContentLoader>
)

export const CategoryDescriptionLoader = () => (
  <ContentLoader speed={2} width={214} height={32}>
    <rect x='0' y='0' rx='10' ry='10' width='214' height='32' />
  </ContentLoader>
)

const ProductLoaderGrid = styled.div(
  (): CSSObject => ({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(124px, auto)',
    gap: '12px',
    width: '100%'
  })
)

const TextLoaderWrapper = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minWidth: 0,
  height: '116px',
  [theme.mediaQueries.viewport7]: {
    height: '126px'
  }
}))

const ImageLoaderWrapper = styled.div<
  StyledHTMLElement & { imageSize: number }
>(({ theme, imageSize }) => ({
  width: `${imageSize}px`,
  height: `${imageSize}px`,
  justifySelf: 'end',
  border: '1px solid #EFEFF0',
  borderRadius: theme.borderRadius,
  position: 'relative'
}))

export const ProductLoader = () => {
  const { isTablet } = useMediaQueries()
  const imageSize = isTablet ? 126 : 116
  const loaderHeight = isTablet ? 126 : 116

  return (
    <ProductLoaderGrid>
      <TextLoaderWrapper>
        <ContentLoader speed={2} height={loaderHeight}>
          <rect x='0' y='0' rx='10' ry='10' width='242' height='32' />
          <rect x='0' y='36' rx='10' ry='10' width='214' height='18' />
          <rect x='0' y='58' rx='10' ry='10' width='144' height='18' />
          <rect x='0' y='85' rx='10' ry='10' width='55' height='20' />
        </ContentLoader>
      </TextLoaderWrapper>
      <ImageLoaderWrapper imageSize={imageSize}>
        <ContentLoader speed={2} width={imageSize} height={imageSize}>
          <rect
            x='0'
            y='0'
            rx='10'
            ry='10'
            width={imageSize}
            height={imageSize}
          />
        </ContentLoader>
      </ImageLoaderWrapper>
    </ProductLoaderGrid>
  )
}

export const CartLoader = () => (
  <ContentLoader speed={1.5} width={10} height={6}>
    <rect x='30' y='0' rx='0' ry='0' width={80} height={6} />
  </ContentLoader>
)

export const StoreLoader = () => (
  <Store>
    <ContentLoader
      speed={2}
      width={400}
      height={44}
      primaryOpacity={0.3}
      secondaryOpacity={0.5}
    />
  </Store>
)

export const StoreListItemLoader = () => (
  <ContentLoader speed={2} width={672} height={268}>
    <rect x='0' y='0' rx='8' ry='8' width='244' height='24' />
    <rect x='252' y='0' rx='8' ry='8' width='70' height='24' />
    <rect x='0' y='40' rx='8' ry='8' width='100%' height='16' />
    <rect x='0' y='58' rx='8' ry='8' width='90%' height='16' />
    <rect x='0' y='88' rx='8' ry='8' width='100%' height='2' />
    <rect x='16%' y='106' rx='20' ry='20' width='20' height='20' />
    <rect x='49%' y='106' rx='20' ry='20' width='20' height='20' />
    <rect x='82%' y='106' rx='20' ry='20' width='20' height='20' />
    <rect x='calc(16% - 50px)' y='130' rx='8' ry='8' width='120' height='14' />
    <rect x='calc(49% - 50px)' y='130' rx='8' ry='8' width='120' height='14' />
    <rect x='calc(82% - 50px)' y='130' rx='8' ry='8' width='120' height='14' />
    <rect x='0' y='160' rx='8' ry='8' width='100%' height='50' />
    <rect x='0' y='218' rx='8' ry='8' width='100%' height='50' />
  </ContentLoader>
)

export const StoreListSortedByLabelLoader = () => (
  <ContentLoader speed={2} width={672} height={16}>
    <rect x='547' y='0' rx='8' ry='8' width='125' height='16' />
  </ContentLoader>
)

const Store = styled(StoreContainer)(({ theme }) => ({
  borderColor: 'transparent',
  cursor: 'auto',
  background: '#f7f7f7',
  padding: 0,
  '&:hover': {
    borderColor: 'transparent'
  },
  [theme.mediaQueries.viewport7]: {
    borderColor: 'transparent',
    padding: 0
  }
}))
